import React from "react";
import {ThemeProvider} from "styled-components";
import {
  FullWidthContainer, Heading1, Heading4,
  Info, InternalLink,
  ListItem,
  MaxWidthContainer,
  Paragraph,
  UnorderedList
} from "../style/itf-styled-components";
import {useThemes} from "../style/themes.hook";
import List from "../components/list/list";
import SEO from "../components/seo";
import Header from "../components/header/header";
import Footer from "../components/footer";
import {useWetickets} from "../data/hooks/wetickets";
import {useYoutickets} from "../data/hooks/youtickets";
import {useVtickets} from "../data/hooks/vtickets";
import {FestivalCategory} from "../components/festival-category";
import CookiesConsent from "../components/cookies-consent";
import {CookiesProvider} from "react-cookie";


const TicketsPage = () => {
  const wetickets = useWetickets();
  const youtickets = useYoutickets();
  const vtickets = useVtickets();
  const themes = useThemes();

  return (
    <>
      <SEO
        title={`Bilete`}
        description={`Cumpără-ți bilet la Imagine Timisoara Festival și rezervă-ți locul la conferință  și la workshopurile pe care ți le dorești.`}
      />
      <ThemeProvider theme={themes.light}>
        <Header page="bilete"/>
        <FullWidthContainer>
          <MaxWidthContainer css={`padding: 50px 25px;`}>
            <Heading1>Bilete</Heading1>
            <Paragraph>Hai la Imagine Timisoara Festival!<br/>Biletele Early Bird sunt acum disponibile.</Paragraph>
            <Paragraph>Asigură-ți locul la conferințele și la workshopurile pe care ți le dorești, din cele trei secțiuni ale festivalului:</Paragraph>
            <UnorderedList>
              <ListItem>
                <Heading4 as={InternalLink} to={"/bilete#weimagine"}>WeImagine (fotografie wedding)</Heading4>
              </ListItem>
              <ListItem>
                <Heading4 as={InternalLink} to={"/bilete#youimagine"}>YouImagine (fotografie non-wedding)</Heading4>
              </ListItem>
              <ListItem>
                <Heading4 as={InternalLink} to={"/bilete#vimagine"}>VImagine (videografie)</Heading4>
              </ListItem>
            </UnorderedList>

            <br/>
            <div
              id="weimagine"
              css={`font-size: 3em;`}
            ><FestivalCategory category={"we"}/></div>
            <List list={wetickets}/>
            <br/>
            <div
              id="youimagine"
              css={`font-size: 3em;`}
            ><FestivalCategory category={"you"}/></div>
            <List list={youtickets}/>
            <br/>
            <div
              id="vimagine"
              css={`font-size: 3em;`}
            ><FestivalCategory category={"v"}/></div>
            <List list={vtickets}/>
            <br/>

            <Info><em>Poți cumpăra bilete la Imagine Timisoara Festival doar de pe site-ul nostru, în două moduri:</em></Info>
            <UnorderedList>
              <ListItem><Info><em>Plata cu cardul, securizată 3D Secure, prin intermediul Ove.ro și Netopia MobilPay</em></Info></ListItem>
              <ListItem><Info><em>Plata prin transfer bancar. În acest caz, plata trebuie să fie efectuată în maximum 2 zile lucrătoare de la comanda biletului. Plata se face în contul RO67CECEB00030RON0567397, beneficiar: Asociatia Imagine Timisoara.</em></Info></ListItem>
              <ListItem><Info><em>Oferim discount de 50% din valoarea biletului la conferințe pentru orice elev și student - în limita a 20% din locurile disponibile la conferințe. Pentru a obține codul tău de reducere, trimite-ne o poză cu carnetul de elev/student prin mail, la <a href="mailto:office@imaginetimisoara.ro">office@imaginetimisoara.ro</a>.</em></Info></ListItem>
            </UnorderedList>
          </MaxWidthContainer>
        </FullWidthContainer>
        <Footer/>

        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      </ThemeProvider>
    </>
  );
};

export default TicketsPage;